import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Form, Field } from "react-final-form";
import { WhenFieldChangesDo } from '../../libraries/forms';
import { ToastContainer, notify } from "../../libraries/notifications";

import { history } from '../../routes';
import config from "../../config";

import productsActions from "../../context/products/actions";

import BottomNav from '../../components/commons/BottomNav';
import Loader from '../../components/commons/Loader';
import Icon from "../../libraries/icons";
import LayoutSmall from "../../components/layout/LayoutSmall";
import ProductCard from "../../components/customs/ProductCard";
import SearchInput from "../../components/forms/SearchInput";
import SelectInput from "../../components/forms/SelectInput";
import { capitalize, toBool } from '../../libraries/utils';

class Products extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      products: [],
      search: "",
      unique_id: this.props.auth.user.unique_id,
      viewAll: true,
    };
  }


  componentDidMount() {
    if(this.props.auth.user?.ancestors){
      let companiesIds = this.props.auth.user.ancestors.companies.map(c => c.id)
      this.setState({companiesIds, unique_id: companiesIds, viewAll: true}, this.getProducts) 
    }
  }

  getProducts = async () => {
    const {search, filters} = this.state
    const params = { status: config.STATUS.PRODUCTS.AVAILABLE, unique_id: this.state.unique_id }

    if (search && search !== ""){
      params.name = `%${search.toLowerCase()}`;
    }

    await this.props.onGetAllProducts(params);
    const { products } = this.props;
    if (products.error) {
      notify(this.t(products.error.message));
    } else {
      this.setState({ products: products.items });
    }
  };

  searchClear = (form) => {
    form.change('search', undefined);
    this.searchOnClick({search: ''});
  }

  searchOnClick = async (values) => {
    console.log("Search on Click", values.search);
    if (this.state.search !== values.search) this.setState({ search: values.search || '' }, () => this.getProducts() );
  };

  goBack = () => {
    history.push({ pathname: config.ROUTES.HOME, state: { from: config.ROUTES.MAIN.OFFER }});
  }

  setViewAll = (viewAll) => {
    let unique_id = this.props.auth.user.unique_id
    this.setState({viewAll, unique_id: viewAll ? this.state.companiesIds : unique_id}, this.getProducts)
  }

  onSubmit = (value) => {
    this.setViewAll(toBool(value));
  }


  render() {
    const { products } = this.state;
    const options = [{ value: true, label: capitalize(this.t('all the accounts')) },{ value: false, label: capitalize(this.t('my office')) }];

    return (
      <LayoutSmall
        main={{ className: "pb-14" }}
        header={{
          title: this.t("Productos"),
          className: "bg-primary",
          left: { icon: 'arrow_left', action: () => this.goBack() },
        }}
        container={{ className: "px-0" }}
      > 
        <ToastContainer />
        {/* <SelectInput className="" selectClassName="bg-transparent p-1" input={{ name: 'select', onChange: this.changeOrigin }} options={options} noError={true} /> */}
        <section className="min-h-full p-4 bg-base-200 max-w-md mx-auto">
          <Form initialValues={{}} onSubmit={this.searchOnClick}>
            {({ handleSubmit, form, submitting, pristine, values }) => (
              <form onSubmit={handleSubmit} className="w-full mb-4">
                <Field name="search" component={SearchInput} placeholder={this.t("Search")} onClick={this.searchOnClick} onClearClick={() => this.searchClear(form) }/>
                <Field name="viewAll" component={SelectInput} className="pt-2" selectClassName="select-ghost select-sm w-40" options={options} noError={true} />
                <WhenFieldChangesDo field="viewAll" action={({ field, value, values }) => { this.onSubmit(value); }} />
              </form>
            )}
          </Form>
          <div>
            { this.props.products.loading && (<Loader/>) }
            {!this.props.products.loading && products.length === 0 && (
              <div className="text-center p-10">
                <Icon className="h-24 w-24 mx-auto mb-3" name="stethoscope" />
                <h4 className="mb-1">{this.t("No hay productos")}</h4>
              </div>
            )}
            <div className="grid grid-cols-2 gap-4">
              { products && products.map((product, index) => {
                  return (
                    <ProductCard 
                      key={'p' + index}
                      route={{ pathname: config.ROUTES.PRODUCTS.DETAIL.replace(':id', product.id), state: { fromPath: config.ROUTES.PRODUCTS.LIST }}}
                      product={product}
                    />
                  )
                })
              }
            </div>
          </div>
        </section>
        <BottomNav/>
      </LayoutSmall>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.users.auth,
    products: state.products.list,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetAllProducts: (params) => dispatch(productsActions.getAll(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Products));

